import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { AnchorLink, Icon, UserPlaceholder } from 'platfi-ui-components';

import styles from './QuickActionUser.scss';

const QuickActionUser = ({ email, name, phoneNumber }) => {
  const userItem = (icon, userDetail, link = '') => (
    <div styleName="m-quick-action-user__item">
      <span styleName="m-quick-action-user__icon">
        <Icon className="a-svg-medium" icon={icon} />
      </span>

      <AnchorLink href={`${link}${userDetail}`} styleName="m-quick-action-user__link">
        {userDetail}
      </AnchorLink>
    </div>
  );

  return (
    <div styleName="m-quick-action-user">
      <div>
        <UserPlaceholder
          bordered
          styleName="m-quick-action-user__placeholder"
          userName={name}
          xsmall
        />

        <div className="u-inline-block u-align-middle">
          <h3 styleName="m-quick-action-user__role">Partnership Manager</h3>

          <h2 styleName="m-quick-action-user__name">{name}</h2>
        </div>
      </div>

      {email && userItem('mail', email, 'mailto:')}

      {phoneNumber && userItem('phone', phoneNumber, 'tel:')}
    </div>
  );
};

QuickActionUser.propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
};

export default CSSModules(QuickActionUser, styles);
